/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Changelog_Nochangelog1Inputs */

const id_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada changelog tersedia`)
};

const ms_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada changelog tersedia`)
};

const da_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ændringslog tilgængelig`)
};

const de_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Änderungsprotokoll verfügbar`)
};

const en_us2_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changelog available`)
};

const es_es2_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay registro de cambios disponible`)
};

const es_mx2_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay registro de cambios disponible`)
};

const fil_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang available na talaan ng pagbabago`)
};

const fr_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun journal disponible`)
};

const it_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun registro modifiche disponibile`)
};

const hu_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem elérhető változásnapló`)
};

const nl_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wijzigingslogboek beschikbaar`)
};

const no_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen endringslogg tilgjengelig`)
};

const pl_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak dziennika zmian`)
};

const pt_br2_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro de alterações disponível`)
};

const pt_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registo de alterações disponível`)
};

const ro_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun jurnal de modificări disponibil`)
};

const fi_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutoslokia ei saatavilla`)
};

const sv_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ändringslogg tillgänglig`)
};

const vi_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có nhật ký thay đổi`)
};

const tr_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik günlüğü mevcut değil`)
};

const cs_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný seznam změn není k dispozici`)
};

const bg_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма наличен дневник на промените`)
};

const ru_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений недоступен`)
};

const uk_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін недоступний`)
};

const ar_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد سجل تغييرات متاح`)
};

const hi_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बदलाव लॉग उपलब्ध नहीं`)
};

const th_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีบันทึกการเปลี่ยนแปลง`)
};

const ja_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能な更新履歴はありません`)
};

const zh_cn2_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无可用更新日志`)
};

const zh_hant1_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無可用更新日誌`)
};

const ko_items_changelog_nochangelog1 = /** @type {(inputs: Items_Changelog_Nochangelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역을 사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "No changelog available" |
*
* @param {Items_Changelog_Nochangelog1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_changelog_nochangelog1 = /** @type {((inputs?: Items_Changelog_Nochangelog1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Changelog_Nochangelog1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_changelog_nochangelog1(inputs)
	if (locale === "ms") return ms_items_changelog_nochangelog1(inputs)
	if (locale === "da") return da_items_changelog_nochangelog1(inputs)
	if (locale === "de") return de_items_changelog_nochangelog1(inputs)
	if (locale === "en-US") return en_us2_items_changelog_nochangelog1(inputs)
	if (locale === "es-ES") return es_es2_items_changelog_nochangelog1(inputs)
	if (locale === "es-MX") return es_mx2_items_changelog_nochangelog1(inputs)
	if (locale === "fil") return fil_items_changelog_nochangelog1(inputs)
	if (locale === "fr") return fr_items_changelog_nochangelog1(inputs)
	if (locale === "it") return it_items_changelog_nochangelog1(inputs)
	if (locale === "hu") return hu_items_changelog_nochangelog1(inputs)
	if (locale === "nl") return nl_items_changelog_nochangelog1(inputs)
	if (locale === "no") return no_items_changelog_nochangelog1(inputs)
	if (locale === "pl") return pl_items_changelog_nochangelog1(inputs)
	if (locale === "pt-BR") return pt_br2_items_changelog_nochangelog1(inputs)
	if (locale === "pt") return pt_items_changelog_nochangelog1(inputs)
	if (locale === "ro") return ro_items_changelog_nochangelog1(inputs)
	if (locale === "fi") return fi_items_changelog_nochangelog1(inputs)
	if (locale === "sv") return sv_items_changelog_nochangelog1(inputs)
	if (locale === "vi") return vi_items_changelog_nochangelog1(inputs)
	if (locale === "tr") return tr_items_changelog_nochangelog1(inputs)
	if (locale === "cs") return cs_items_changelog_nochangelog1(inputs)
	if (locale === "bg") return bg_items_changelog_nochangelog1(inputs)
	if (locale === "ru") return ru_items_changelog_nochangelog1(inputs)
	if (locale === "uk") return uk_items_changelog_nochangelog1(inputs)
	if (locale === "ar") return ar_items_changelog_nochangelog1(inputs)
	if (locale === "hi") return hi_items_changelog_nochangelog1(inputs)
	if (locale === "th") return th_items_changelog_nochangelog1(inputs)
	if (locale === "ja") return ja_items_changelog_nochangelog1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_changelog_nochangelog1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_changelog_nochangelog1(inputs)
	return ko_items_changelog_nochangelog1(inputs)
});
export { items_changelog_nochangelog1 as "items.changelog.noChangelog" }